/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons/faCaretRight';
import { faCaretLeft } from '@fortawesome/free-solid-svg-icons/faCaretLeft';

import Modal from '../modal';
import Button from '../button';

import styles from './styles.css';

export default function CompetitiveIndexTooltip() {
  const [showModal, setShowModal] = React.useState(false);
  const [showLearnMore, setShowLearnMore] = React.useState(false);

  const handleOnInfoCircleClick = () => setShowModal(true);

  const handleOnModalClose = () => setShowModal(false);

  return (
    <>
      <FontAwesomeIcon
        icon={faInfoCircle}
        onClick={handleOnInfoCircleClick}
        className={styles.competitiveIndexTooltip}
      />
      <Modal onClose={handleOnModalClose} show={showModal}>
        <div className={styles.competitiveIndexModal}>
          <div style={{ fontWeight: 500 }}>
            {!showLearnMore ? (
              <>
                <h2 className={styles.competitiveIndexTitle}>GasBuddy Competitive Index (CI)</h2>
                <div>
                  <ul style={{ fontSize: '12px' }}>
                    <li>
                      <div>
                      Identify your over/under-performing stations with an easy to recognize score from 1-99, where the industry average score is 50.
                      </div>
                    </li>
                    <li><div>This index is normalized so that you can benchmark against any size of competitor.</div></li>
                    <li><div>Understand how competitive you are at a brand, region, or station level against the competition</div></li>
                    <li>
                      <div>
                        {`
                         To qualify for a score the station has to have a rich enough data set to show you how competitive you are in
                         your trade area. We will not provide a station with a score until there is enough data available.
                        `}
                      </div>
                    </li>
                    <li>
                      <div>
                        {`
                          You can improve your Index by implementing holistic offline strategies that focus on improving your customer
                          experience and differentiating your business to win more market share.
                        `}
                      </div>
                    </li>
                  </ul>
                </div>
                <div style={{ minHeight: '21px' }}>
                  <a role="button" className={styles.learnMore} alt="Learn More" onClick={() => setShowLearnMore(true)}>
                    Learn more
                    {' '}
                    <FontAwesomeIcon icon={faCaretRight} style={{ marginLeft: '8px' }} />
                  </a>
                </div>
              </>
            ) : (
              <>
                <h2 className={styles.competitiveIndexTitle}>How is CI calculated?</h2>
                <div className={styles.subContent}>
                  <div className={styles.subContentContainer}>
                    <h6>Share of Locale</h6>
                    <div>How well are you performing compared to how you would be expected to perform against competitors in your trade area?</div>
                  </div>
                  <br />
                  <div className={styles.subContentContainer}>
                    <h6>Visit Loyalty</h6>
                    <div>
                      What percent of consumers in your area are loyal to your brand or stations compared to other stations and brands around you?
                    </div>
                  </div>
                  <br />
                  <div className={styles.subContentContainer}>
                    <h6>Same-Price Variation</h6>
                    <div>How well are your performing relative to your competition who price their fuel very similar to you?</div>
                  </div>
                  <br />
                </div>
                <div>
                  <a role="button" className={styles.back} alt="Back" onClick={() => setShowLearnMore(false)}>
                    <FontAwesomeIcon icon={faCaretLeft} style={{ marginRight: '8px' }} />
                    {' '}
                    Back
                  </a>
                </div>
              </>
            )}
            <div style={{ textAlign: 'center' }}>
              <Button wide primary onClick={() => setShowModal(false)}>Got it</Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}
